// extracted by mini-css-extract-plugin
export var hrWhite = "hr-module--hr-white--Gjw7k";
export var hrBlack = "hr-module--hr-black--2FbDY";
export var hrLight = "hr-module--hr-light--3PWRj";